// extracted by mini-css-extract-plugin
export default {"notificationsList":"JnUthrJZVUNOXcmvSkxt","controls":"NziAdO_NVvOiKCK5as5N"};